import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import _cloneDeep from 'lodash/cloneDeep';

const defIsGlobalLoading = false;
const defGlobalLoadingCounter = 0;

const usePrivateLoaderStore = defineStore('_loader', () => {
  const isGlobalLoading = ref(_cloneDeep(defIsGlobalLoading));
  const globalLoadingCounter = ref(_cloneDeep(defGlobalLoadingCounter));
  function $reset(): void {
    isGlobalLoading.value = _cloneDeep(defIsGlobalLoading);
    globalLoadingCounter.value = _cloneDeep(defGlobalLoadingCounter);
  }
  return { isGlobalLoading, globalLoadingCounter, $reset };
});

export const useLoaderStore = defineStore('loader', () => {
  // it is usually a bad practice to keep private properties in stores
  // https://pinia.vuejs.org/core-concepts/#Setup-Stores
  // https://pinia.vuejs.org/cookbook/composables.html#Setup-Stores
  // https://masteringpinia.com/blog/how-to-create-private-state-in-stores
  // const _isGlobalLoading = ref(false);

  const _loaderStore = usePrivateLoaderStore();

  function $reset(): void {
    _loaderStore.$reset();
  }

  const isGlobalLoading = computed(() => {
    return _loaderStore.isGlobalLoading || !!_loaderStore.globalLoadingCounter;
  });

  function setGlobalLoader(isEnabled: boolean): void {
    _loaderStore.isGlobalLoading = isEnabled;
  }

  function increaseGlobalLoader(): void {
    _loaderStore.globalLoadingCounter = _loaderStore.globalLoadingCounter + 1;
  }

  // decreaseGlobalLoader must always be used in finally block after increaseGlobalLoader
  function decreaseGlobalLoader(): void {
    _loaderStore.globalLoadingCounter = _loaderStore.globalLoadingCounter - 1;
  }

  return {
    $reset,
    isGlobalLoading,
    setGlobalLoader,
    increaseGlobalLoader,
    decreaseGlobalLoader,
  };
});
